import { css } from 'styled-components';
import { minWidth } from './mediaQueries';
// Sizes are in rem, with pixel translations for mobile and not-mobile in comments
export const FontSizes = {
    sm: 0.75, // 12px / 13.5px / small
    base: 1, // 16px / 18px / headline / body
    lg: 1.25, // 20px / 22.5px / title2
    xl: 1.5, // 24px / 27px // TODO: potentially deprecate
    '2xl': 1.75, // 28px / 31.5px / title1
    '3xl': 2.25, // 36px / 40.5px // TODO: potentially deprecate
    '4xl': 2.75, // 44px / 49.5px / hero
};
// Font sizes that shift in rem value on mobile devices
const MobileFontSizes = {
    sm: undefined,
    base: undefined,
    lg: undefined,
    xl: undefined,
    '2xl': 1.5,
    '3xl': undefined,
    '4xl': undefined,
};
export const fontSize = (size) => {
    const fontSizeKey = Object.keys(FontSizes).find(k => FontSizes[k] === size);
    const mobileFontSizeValue = fontSizeKey ? MobileFontSizes[fontSizeKey] : undefined;
    return css `
		font-size: ${mobileFontSizeValue !== null && mobileFontSizeValue !== void 0 ? mobileFontSizeValue : size}rem;
		${minWidth('mobileLarge')} {
			font-size: ${size * 1.125}rem;
		}
	`;
};
// These line heights are the closest to our "usual" 1.5 that put R18 fonts on an 8px grid
export const R18LineHeightsByFontSize = {
    [FontSizes.sm]: '20px',
    [FontSizes.base]: '28px',
    [FontSizes.lg]: '32px',
    [FontSizes.xl]: '40px',
    [FontSizes['2xl']]: '48px',
    [FontSizes['3xl']]: '60px',
    [FontSizes['4xl']]: '72px',
};
export const lineHeight = (size) => css `
	line-height: 150%;
	${minWidth('mobileLarge')} {
		line-height: ${R18LineHeightsByFontSize[size]};
	}
`;
export const FontWeights = {
    Light: 300,
    Regular: 400,
    Medium: 500,
    Demi: 700,
};
export const fontWeight = (weight) => css `
	font-weight: ${weight};
`;
export const fontFamily = css `
	font-family: 'Avenir Next', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
`;
//# sourceMappingURL=typography.js.map